"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VisaIcon = function VisaIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    viewBox = _ref.viewBox,
    isDark = _ref.isDark;
  var light = {
    v: '#0066B3',
    i: '#0066B3',
    s: '#0066B3',
    a: '#0066B3',
    arrow: '#FAA634'
  };
  var dark = {
    v: '#676767',
    i: '#676767',
    s: '#676767',
    a: '#676767',
    arrow: '#666666'
  };
  var fill = light;
  if (isDark) {
    fill = dark;
  }
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "i",
    d: "M21.0784 31H18L19.9216 17H23L21.0784 31Z",
    fill: fill.i
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "v",
    d: "M14.9709 17L11.4103 26.6292L10.9916 24.5543L9.73181 18.2584C9.73181 18.2584 9.58202 17 7.96114 17H2.06914L2 17.236C3.37948 17.5711 4.69815 18.1105 5.91008 18.8352L9.15567 31H13.0504L19 17H14.9709Z",
    fill: fill.v
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "a",
    d: "M42.644 31H46L43.0719 17.0047H40.1363C39.7796 16.978 39.4237 17.0657 39.1205 17.2549C38.8172 17.4442 38.5826 17.7251 38.4508 18.0568L33 31H36.799L37.5498 28.922H42.1972L42.644 31ZM38.6234 26.0504L40.5417 20.8087L41.6229 26.0504H38.6234Z",
    fill: fill.a
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "s",
    d: "M33.4746 20.487L34 17.5902C32.9372 17.2265 31.8207 17.0273 30.6924 17C28.8667 17 24.5309 17.764 24.5309 21.4791C24.5309 24.9769 29.6189 25.0204 29.6189 26.8562C29.6189 28.692 25.0526 28.3662 23.5481 27.2183L23 30.2346C24.3161 30.7616 25.7318 31.0217 27.1581 30.9986C29.668 30.9986 33.4557 29.753 33.4557 26.3674C33.4519 22.8478 28.3186 22.5183 28.3186 20.9903C28.3186 19.4622 31.9021 19.6542 33.4746 20.487Z",
    fill: fill.s
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "arrow",
    d: "M11 25L9.739 18.3327C9.739 18.3327 9.58906 17 7.96668 17H2.0692L2 17.2499C4.02997 17.7838 5.92384 18.7648 7.55147 20.1254C9.09846 21.4072 10.2884 23.0892 11 25Z",
    fill: fill.arrow
  }));
};
VisaIcon.defaultProps = {
  isDark: false,
  width: '48',
  height: '48',
  viewBox: '0 0 48 48'
};
VisaIcon.propTypes = {
  /**
   * use darkTheme
   */
  isDark: _propTypes["default"].bool,
  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,
  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,
  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string
};
var _default = exports["default"] = VisaIcon;